(function () {
  function normalizeBrand(value) {
    var normalized = String(value || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    if (normalized === 'ducio-di-segna') normalized = 'duccio-di-segna';
    return normalized;
  }

  function brandsMatch(a, b) {
    if (!a || !b) return false;
    var left = normalizeBrand(a);
    var right = normalizeBrand(b);
    if (left === right) return true;
    if (left === 'list-' + right || right === 'list-' + left) return true;
    return false;
  }

  function getTabListHandle(tab) {
    if (!tab) return '';
    return normalizeBrand(tab.dataset.brandList || tab.dataset.brandHandle || '');
  }

  function getItemListHandle(item) {
    return normalizeBrand(
      item.dataset.brandList || item.getAttribute('data-brand-list') || item.dataset.brand || ''
    );
  }

  function isCollectionsDirectoryPage() {
    var path = (window.location.pathname || '').replace(/\/+$/, '') || '/';
    return path === '/collections' || path === '/collections/all';
  }

  function getCollectionItems() {
    var section = document.querySelector('[data-collection-list-section]');
    if (!section) {
      return Array.prototype.slice.call(
        document.querySelectorAll('[data-collection-list-section] .resource-list__item')
      );
    }
    var root = section.querySelector('.collection-list__results .resource-list');
    if (root) {
      return Array.prototype.slice.call(root.querySelectorAll('.resource-list__item'));
    }
    return Array.prototype.slice.call(section.querySelectorAll('.resource-list__item'));
  }

  function initBrandTabs() {
    var brandTabs = document.querySelector('.new-collection-tabs--brand');
    if (!brandTabs || brandTabs.dataset.brandTabsReady === 'true') return;
    brandTabs.dataset.brandTabsReady = 'true';

    var allTab = brandTabs.querySelector('[data-brand-all="true"]');

    function getBrandFacetContext() {
      var forms = Array.prototype.slice.call(document.querySelectorAll('facets-form-component'));
      var facetsForm = forms.find(function (form) {
        return !form.closest('dialog');
      });
      if (!facetsForm) return null;

      var inputs = Array.prototype.slice.call(
        facetsForm.querySelectorAll('input[type="checkbox"][name^="filter."]')
      ).filter(function (input) {
        return input.name.toLowerCase().indexOf('brand') !== -1;
      });

      return inputs.length ? { facetsForm: facetsForm, inputs: inputs } : null;
    }

    function shouldUseCollectionCards() {
      if (isCollectionsDirectoryPage()) return true;
      return getCollectionItems().length > 0;
    }

    function scrollTabIntoContainer(tab) {
      var container = brandTabs.querySelector('.new-collection-tabs__container');
      if (!tab || !container) return;
      var isRtl = getComputedStyle(container).direction === 'rtl';
      tab.scrollIntoView({
        behavior: 'auto',
        block: 'nearest',
        inline: isRtl ? 'start' : 'nearest',
      });
    }

    function setActiveBrandTab(activeTab) {
      var tabs = brandTabs.querySelectorAll('.new-collection-tabs__item');
      Array.prototype.forEach.call(tabs, function (tab) {
        tab.classList.remove('new-collection-tabs__item--active');
        tab.dataset.isActive = 'false';
      });
      if (activeTab) {
        activeTab.style.display = '';
        activeTab.classList.add('new-collection-tabs__item--active');
        activeTab.dataset.isActive = 'true';
        scrollTabIntoContainer(activeTab);
      }
    }

    function shouldPersistBrandInUrl(brandHandle) {
      var normalized = normalizeBrand(brandHandle);
      return normalized && normalized !== 'other-brands' && normalized !== 'list-other-brands';
    }

    function updateBrandUrl(brandHandle) {
      var url = new URL(window.location.href);
      if (!shouldPersistBrandInUrl(brandHandle)) {
        url.searchParams.delete('brand');
      } else {
        url.searchParams.set('brand', normalizeBrand(brandHandle));
      }
      window.history.replaceState({}, '', url);
    }

    function findTabForBrand(brandHandle) {
      if (!brandHandle) return allTab;
      var normalized = normalizeBrand(brandHandle);
      var match = null;
      var tabs = brandTabs.querySelectorAll('.new-collection-tabs__item[data-brand-handle]');
      Array.prototype.forEach.call(tabs, function (tab) {
        if (tab.dataset.brandAll === 'true') return;
        if (brandsMatch(getTabListHandle(tab), normalized)) match = tab;
      });
      if (match) match.style.display = '';
      return match;
    }

    function getSelectedFacetBrand() {
      var context = getBrandFacetContext();
      if (!context) return '';

      var url = new URL(window.location.href);
      var selectedValues = [];
      context.inputs.forEach(function (input) {
        url.searchParams.getAll(input.name).forEach(function (value) {
          if (selectedValues.indexOf(value) === -1) selectedValues.push(value);
        });
      });

      return selectedValues.length === 1 ? normalizeBrand(selectedValues[0]) : '';
    }

    function syncFacetBrandTab() {
      var context = getBrandFacetContext();
      if (!context) return;

      var selectedBrand = getSelectedFacetBrand();
      if (!selectedBrand) {
        setActiveBrandTab(allTab);
        return;
      }

      setActiveBrandTab(findTabForBrand(selectedBrand));
    }

    function applyFacetBrandSelection(brandHandle) {
      var context = getBrandFacetContext();
      if (!context) return;

      var requestedBrand = normalizeBrand(brandHandle);
      var matchingInput = requestedBrand
        ? context.inputs.find(function (input) {
            return brandsMatch(input.value, requestedBrand);
          })
        : null;
      var url = new URL(window.location.href);

      context.inputs.forEach(function (input) {
        url.searchParams.delete(input.name);
      });
      url.searchParams.delete('brand');
      url.searchParams.delete('page');

      if (matchingInput) {
        url.searchParams.append(matchingInput.name, matchingInput.value);
        setActiveBrandTab(findTabForBrand(requestedBrand));
      } else {
        setActiveBrandTab(allTab);
      }

      if (typeof context.facetsForm.updateFiltersByURL === 'function') {
        context.facetsForm.updateFiltersByURL(url.toString());
      } else {
        window.location.href = url.toString();
      }
    }

    function itemMatchesBrand(item, normalized) {
      if (!normalized) return true;
      var itemListHandle = getItemListHandle(item);
      return itemListHandle && brandsMatch(itemListHandle, normalized);
    }

    function filterCollectionItems(brandHandle) {
      var items = getCollectionItems();
      if (!items.length) return 0;
      var normalized = normalizeBrand(brandHandle);
      var visibleCount = 0;

      items.forEach(function (item) {
        if (!normalized) {
          item.classList.remove('is-brand-filter-hidden');
          visibleCount += 1;
          return;
        }

        var visible = itemMatchesBrand(item, normalized);
        item.classList.toggle('is-brand-filter-hidden', !visible);
        if (visible) visibleCount += 1;
      });

      return visibleCount;
    }

    function showAllBrandTabs() {
      var tabs = brandTabs.querySelectorAll('.new-collection-tabs__item');
      Array.prototype.forEach.call(tabs, function (tab) {
        tab.style.display = '';
      });
    }

    function applyCollectionCardBrandSelection(brandHandle) {
      var requestedHandle = normalizeBrand(brandHandle);

      if (!requestedHandle) {
        setActiveBrandTab(allTab);
        filterCollectionItems('');
        updateBrandUrl('');
        showAllBrandTabs();
        return;
      }

      var activeTab = findTabForBrand(requestedHandle);
      var resolvedHandle = activeTab ? getTabListHandle(activeTab) : requestedHandle;
      var visibleCount = filterCollectionItems(resolvedHandle);

      if (visibleCount === 0 && !isCollectionsDirectoryPage()) {
        var brandUrl = activeTab && (activeTab.getAttribute('data-brand-url') || '');
        if (brandUrl) {
          window.location.assign(brandUrl);
          return;
        }
      }

      if (activeTab) {
        setActiveBrandTab(activeTab);
      } else if (visibleCount === 0) {
        setActiveBrandTab(allTab);
        filterCollectionItems('');
        updateBrandUrl('');
        showAllBrandTabs();
        return;
      } else {
        setActiveBrandTab(null);
      }

      updateBrandUrl(resolvedHandle);
      showAllBrandTabs();
    }

    function applyBrandSelection(brandHandle) {
      if (shouldUseCollectionCards()) {
        applyCollectionCardBrandSelection(brandHandle);
        return;
      }
      applyFacetBrandSelection(brandHandle);
    }

    brandTabs.addEventListener('click', function (e) {
      var tab = e.target.closest('.new-collection-tabs__item');
      if (!tab || tab.style.display === 'none') return;

      e.preventDefault();
      e.stopPropagation();

      if (tab.dataset.brandAll === 'true') {
        applyBrandSelection('');
        return;
      }

      if (tab.classList.contains('new-collection-tabs__item--active')) {
        applyBrandSelection('');
        return;
      }

      applyBrandSelection(getTabListHandle(tab));
    });

    function runInitialSelection() {
      var params = new URLSearchParams(window.location.search);
      var initial = normalizeBrand(params.get('brand') || params.get('list') || '');
      applyBrandSelection(initial || '');
    }

    if (shouldUseCollectionCards()) {
      runInitialSelection();
    } else {
      syncFacetBrandTab();
      document.addEventListener('filter:update', function () {
        window.requestAnimationFrame(syncFacetBrandTab);
      });
    }

    window.addEventListener('popstate', function () {
      if (!shouldUseCollectionCards()) {
        window.requestAnimationFrame(syncFacetBrandTab);
        return;
      }
      var params = new URLSearchParams(window.location.search);
      applyBrandSelection(normalizeBrand(params.get('brand') || params.get('list') || '') || '');
    });
  }

  function bootBrandTabs() {
    initBrandTabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootBrandTabs);
  } else {
    bootBrandTabs();
  }

  window.addEventListener('load', bootBrandTabs);
  document.addEventListener('shopify:section:load', bootBrandTabs);
})();
